import con, { mutationTypes } from '../mutationTypes';

import { functions as firebaseFunctions } from '../../firebase';
import config from '../../firebase.config';

const CALLABLE = Symbol('callable');
const REQUEST = Symbol('request');
const region = firebaseFunctions.region_;

const getFunctionUrl = name =>
  new URL(`https://${region}-${config.projectId}.cloudfunctions.net/${name}`);

mutationTypes.addModule('functions', true);

mutationTypes.add('functions', [
  'FUNCTIONS_CALLING_INIT',
  'FUNCTIONS_CALLING_DONE',
  'FUNCTIONS_CALLING_ERROR'
]);

const functions = {
  namespaced: true,
  state: {
    list: [
      {
        name: 'unsafe_adminChallengesPublish',
        params: ['authToken'],
        type: REQUEST
      },
      {
        name: 'unsafe_adminChallengesPublishAll',
        params: ['authToken', 'publishLevel'],
        type: REQUEST
      },
      {
        name: 'unsafe_adminConceptsPublishAll',
        params: ['authToken', 'publishType'],
        type: REQUEST
      },
      {
        name: 'unsafe_algoliaManualSync',
        params: ['authToken'],
        type: REQUEST
      },
      {
        name: 'unsafe_algoliaUpdateSettings',
        params: ['authToken'],
        type: REQUEST
      },
      {
        name: 'unsafe_conceptAttemptsCreate',
        params: ['authToken', 'conceptId'],
        type: REQUEST
      },
      {
        name: 'adminOverallAnalyticsGet',
        params: [],
        type: CALLABLE,
        private: true
      },
      {
        name: 'unsafe_adminSendTestMail',
        params: ['authToken', 'email', 'name'],
        type: REQUEST
      }
    ],
    calling: '',
    result: null,
    callError: null
  },
  mutations: {
    [con.FUNCTIONS_CALLING_INIT](state, functionName) {
      state.error = null;
      state.result = null;
      state.calling = functionName;
    },
    [con.FUNCTIONS_CALLING_DONE](state, result) {
      state.calling = '';
      state.result = result;
    },
    [con.FUNCTIONS_CALLING_ERROR](state, error) {
      state.calling = '';
      state.callError = error;
    }
  },
  actions: {
    async callFunction({ commit, state }, data) {
      const functionDetails = state.list.find(f => f.name === data.name);
      commit(con.FUNCTIONS_CALLING_INIT, functionDetails.name);
      try {
        if (functionDetails.type === CALLABLE) {
          const result = await firebaseFunctions.httpsCallable(data.name)(
            data.params
          );
          commit(con.FUNCTIONS_CALLING_DONE, result.data);
          return result.data;
        } else if (functionDetails.type === REQUEST) {
          const url = getFunctionUrl(data.name);
          Object.keys(data.params).forEach(key =>
            url.searchParams.append(key, data.params[key])
          );
          // Using mode 'no-cors' for now, We will not know status of the request
          // as no-cors returns false for all the requests.
          const result = await fetch(url, { mode: 'no-cors' });
          commit(con.FUNCTIONS_CALLING_DONE, result);
          return result;
        }
        return null;
      } catch (error) {
        commit(con.FUNCTIONS_CALLING_ERROR, error);
        throw error;
      }
    }
  }
};

export default functions;
